import { CDN_URL } from '../../config.js';

export const HAIR_COLOR_CATEGORIES = [
  { id: 'specific-colors', label: 'Specific colors' },
  { id: 'multiple-colors', label: 'Multiple colors' },
];

const slugify = (tag) => tag
  .toLowerCase()
  .replace(/[()]/g, '')
  .trim()
  .replace(/\s+/g, '-')
  .replace(/-+/g, '-');

const specific = (tag) => ({
  tag,
  slug: slugify(tag),
  categories: ['specific-colors'],
});

const multiple = (tag) => ({
  tag,
  slug: slugify(tag),
  categories: ['multiple-colors'],
});

export const HAIR_COLORS = [
  specific('aqua hair'),
  specific('black hair'),
  specific('blonde hair'),
  specific('blue hair'),
  specific('brown hair'),
  specific('green hair'),
  specific('grey hair'),
  specific('orange hair'),
  specific('pink hair'),
  specific('purple hair'),
  specific('red hair'),
  specific('white hair'),
  multiple('multicolored hair'),
  multiple('colored inner hair'),
  multiple('colored tips'),
  multiple('gradient hair'),
  multiple('rainbow hair'),
  multiple('split-color hair'),
  multiple('streaked hair'),
  multiple('two-tone hair'),
];

export const hairColorImageUrl = (slug) => `${CDN_URL}/data/hair/hair_color/${slug}_small.webp`;
